export default function initAccordion() {
	document.querySelectorAll('.accordion-container').forEach(container => {
		container.querySelectorAll('.accordion-trigger').forEach(trigger => {
			const content = trigger.nextElementSibling;
			content.classList.add = 'overflow-hidden';
			content.style.transition = 'max-height 0.3s cubic-bezier(0.4,0,0.2,1)';
			content.style.maxHeight = '0px';

			const icon = trigger.querySelector('.icon.icon--chevron--gray-700');

			trigger.addEventListener('click', () => {
				container.querySelectorAll('.accordion-content').forEach(el => {
					const elTrigger = el.previousElementSibling;
					const elIcon = elTrigger ? elTrigger.querySelector('.icon.icon--chevron--gray-700') : null;
					if (el !== content) {
						el.style.maxHeight = '0px';
						el.classList.remove('!mt-4');
						el.parentElement.classList.remove('bg-white');
						if (elIcon) elIcon.classList.remove('rotate-90');
					} else {
						el.classList.toggle('!mt-4');
						el.parentElement.classList.toggle('bg-white');
						if (icon) icon.classList.toggle('rotate-90');
					}
				});

				if (content.style.maxHeight === '0px' || !content.style.maxHeight) {
					content.style.maxHeight = content.scrollHeight + 'px';
				} else {
					content.style.maxHeight = '0px';
				}
			});
		});
	});
}
